import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about-wrapper py-5">
      <div className="container">
        <h2 className="mb-4 fw-bold text-center">Hakkımızda</h2>
        <p className="lead text-center mb-5">Eren Oto Yedek Parça — Güven, Kalite ve Deneyimin Buluşma Noktası</p>

        <div className="about-section mb-5">
          <p>
            Eren Oto Yedek Parça olarak, otomotiv sektöründe 10 yılı aşkın tecrübemizle müşterilerimize en kaliteli hizmeti sunmaktan gurur duyuyoruz. Audi, Volkswagen, Seat, Skoda, Porsche, BMW ve Mercedes markalarına özel orijinal ve muadil yedek parça çözümlerimizle hem bireysel müşterilerimizin hem de servis noktalarının ihtiyaçlarına hızlı ve güvenilir çözümler sunuyoruz.
          </p>
          <p>
            İstanbul’un kalbinde konumlanmış olan firmamız, geniş ürün yelpazesi, deneyimli personeli ve müşteri odaklı hizmet anlayışıyla sektörde fark yaratmaktadır. Elektrik, kaporta ve mekanik aksamlar başta olmak üzere araçlarınız için her zaman en doğru parçayı bulmanızı sağlıyoruz.
          </p>
          <p>
            Gelişen teknolojiye ayak uyduran altyapımız ve dinamik lojistik ağımız sayesinde Türkiye’nin dört bir yanına hızlı sevkiyat imkânı sunuyoruz. Yedek parça tedariği sürecini en verimli hale getiriyor, ihtiyaç duyduğunuzda teknik destekle her zaman yanınızda oluyoruz.
          </p>
          <p>
            Kaliteden ödün vermeyen yapımızla, sektördeki yenilikleri yakından takip ederek sizlere en güncel ve doğru ürünleri sunmayı sürdüreceğiz. Eren Oto, sadece bir parça tedarikçisi değil; aynı zamanda güvenilir bir iş ortağınızdır.
          </p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <img src="/images/erenoto.webp" alt="Eren Oto İç Görünüm" className="img-fluid rounded shadow-sm" />
          </div>
          <div className="col-md-6 col-lg-4">
            <img src="/images/erenoto2.webp" alt="Mağaza Önü" className="img-fluid rounded shadow-sm" />
          </div>
          <div className="col-md-6 col-lg-4">
            <img src="/images/erenoto3.webp" alt="İç Görünüm 2" className="img-fluid rounded shadow-sm" />
          </div>
          <div className="col-md-6 col-lg-4">
            <img src="/images/erenoto4.webp" alt="Dış Cephe" className="img-fluid rounded shadow-sm" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
